<template>
  <div class="scan-input-container">
    <div class="basic-scan-input-container">
      <Field
        v-slot="{ field }"
        v-model="mutatedValue"
        :label="label"
        :name="name"
        :rules="validation"
      >
        <label class="bordered-bottom">
          <span v-if="displayLabel">{{ label }} {{ validation.split('|').includes('required') ? '*' : '' }}</span>
          <input
            :ref="name"
            type="text"
            class="bordered-bottom"
            :disabled="disabledInteractionComputed"
            v-bind="field"
            :placeholder="`${placeholderValue} ${
              !displayLabel && validation.split('|').includes('required') ? '*' : ''
            }`"
            :maxlength="mutatedMaxLength"
            :readonly="isReadOnly"
            autocomplete="false"
            @input="onInput($event.target.value)"
          >
          <img
            v-if="![null, undefined, ''].includes(mutatedValue)"
            class="form-generator-clear-button"
            src="@/assets/icons/cancel.svg"
            alt="clear input"
            @click="clearInput"
          >
        </label>
        <ErrorMessage
          class="error-msg"
          :name="name"
        />
      </Field>
    </div>
    <!--  Scan product  -->
    <div
      v-if="displayBarcode"
      class="barcode-container"
      @click="startScanner"
    >
      <img
        alt="Barcode"
        class="barcode-image"
        src="@/assets/icons/barcode.png"
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { store } from '@/stores/index.js'
import { appConfigurationStore } from '@/stores/appConfigurationStore.js'
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * placeholder: placeholder that'll be set inside the textarea (string)
 * value: text that'll be set inside the input, if null, then the placeholder we'll be displayed (string)
 * name: input's name (string)
 */
export default {
  name: 'BasicScanInput',
  components: { Field, ErrorMessage },
  expose: ['clearInput'],
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: String,
    name: String,
    defaultValue: [String, Array],
    disabledInteraction: Boolean,
    getValidationValue: {
      type: Function,
      default: null
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    displayLabel: {
      type: Boolean,
      default: false
    },
    searchByScan: {
      type: Boolean,
      default: false
    }
  },
  emits: ['addData'],
  data() {
    return {
      mutatedValue: this.defaultValue,
      placeholderValue: this.placeholder
    }
  },
  computed: {
    ...mapState(store, { scannedScanInput: 'scannedScanInput' }),
    ...mapState(appConfigurationStore, ['appConfiguration']),
    mutatedMaxLength() {
      return this.getValidationValue(this.validation, 'max')
    },
    disabledInteractionComputed() {
      if (this.disabledInteraction) {
        return this.defaultValue.length !== 0
      }
      return false
    },
    displayBarcode() {
      return this.appConfiguration?.modules?.scan?.searchCustomerByCardNumber
    }
  },
  watch: {
    scannedScanInput: function () {
      if (this.scannedScanInput != '') {
        this.mutatedValue = this.scannedScanInput
        this.onInput()
        this.$store.setScannedScanInput('')
      }
    }
  },
  mounted() {
    if (this.$route.name === 'searchCustomer' && this.searchByScan === true) {
      this.mutatedValue = ''
    }
    this.mutatedValue
      ? this.$emit('addData', { value: this.mutatedValue, name: this.name })
      : this.$emit('addData', { value: '', name: this.name })
  },
  methods: {
    onInput(value = null) {
      this.$emit('addData', { value, name: this.name })
    },
    /**
     * Start Scanner
     */
    startScanner() {
      if (typeof android !== 'undefined') {
        android.startScanner()
      } else if (window.ios === true) {
        window.location.href = 'octiapp://barcode-scanner'
      }
    },
    clearInput() {
      this.mutatedValue = ''
      this.onInput()
    }
  }
}
</script>

<style lang="scss" scoped>
  .scan-input-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }

  .basic-scan-input-container {
    width: 100%;
    margin: 10px 0;

    /* Tablet (portrait) */
    @media only screen and (width >= 768px) {
      margin: 20px 0;
    }

    /* Desktops and laptops */
    @media only screen and (width >= 1024px) {
      margin: 20px 0;
    }

    /* Large screens */
    @media only screen and (width >= 1824px) {
      margin: 20px 0;
    }

    label {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      white-space: nowrap;
      align-items: center;
      padding-left: 0.5rem;

      span {
        font-weight: bolder;
        margin-right: 1rem;
      }

      input {
        border: none;
        flex-grow: 1;
      }
    }
  }

  .barcode-image {
    height: 25px;
  }

  .barcode-container {
    display: flex;
    margin-left: 1rem;
  }
</style>
